import { Box } from '@mui/material'
import styled from 'styled-components'

const RemovedImagePlaceholder = ({
  message = 'Image was removed'
}) => {
  return (
    <Container>
      {message && <Message>{message}</Message>}
    </Container>
  )
}

const Container = styled(Box)`
  background: rgb(247, 247, 247);
  padding: 10px;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
`

const Message = styled.div`
  margin-top: 16px;
  font-size: 16px;
  color: #666;
  text-align: center;
  font-weight: 500;
`

export default RemovedImagePlaceholder
